// extracted by mini-css-extract-plugin
export default {"red":"#d32f2f","orange":"#f57c00","yellow":"#fbc02d","green":"#7cb342","blue":"#1b5e3c"};